var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalviaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "329mm",
    height: "330.22mm",
    viewBox: "0 0 329 330.22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.137 61.823)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1639.2 2140.6)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -76.036 96.989)",
    d: "m7227-8402.5-118.51 63.652c10.826 24.314 19.057 49.867 24.316 76.277 3.4855 17.504 5.6024 37.923 6.3555 58.453l133.91-20.783c-0.137-2.3373-0.2843-4.6298-0.4707-6.7304-5.3636-60.422-20.743-117.7-45.6-170.87z",
    fill: "#b80099",
    strokeWidth: 1.7011
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -76.036 96.989)",
    d: "m6989.7-8641.4-63.387 118.32c16 7.3105 31.611 15.833 46.688 25.6 38.295 24.807 71.193 56.435 97.443 92.76l119.18-64.012c-7.9669-11.975-16.432-23.707-25.508-35.123-16.125-20.282-57.671-61.567-78.549-78.055-29.874-23.593-62.09-43.426-95.869-59.492z",
    fill: "#b16bc9",
    strokeWidth: 1.7011
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.26458 0 0 .26458 -76.036 96.989)",
    d: "m6775.4-8690.6c-25.695-0.091-51.48 1.8174-77.123 5.7832-105.41 16.304-201.53 65.16-277.34 140.96-130.3 130.3-177.79 317.46-125.8 495.73 22.237 76.236 63.012 145.94 119.9 204.95 79.151 82.111 178.84 132.4 294.44 148.52 29.423 4.1046 97.866 4.1046 127.29 0 67.65-9.4371 136.79-32.859 187.87-63.641l9.9551-6 151.65 151.35c140.82 140.53 152.52 151.8 163.9 157.63 17.465 8.9594 34.921 13.035 54.795 12.795 8.9726-0.1096 17.844-0.5402 19.715-0.9589 42.705-9.5577 75.403-38.9 88.752-79.646 3.6858-11.25 4.4695-16.852 4.5273-32.32 0.1021-27.158-6.5951-48.293-21.771-68.715-3.2024-4.3094-71.676-73.646-152.16-154.08l-146.34-146.24 3.5703-6.0079c35.913-60.418 57.459-120.56 67.973-189.73 1.351-8.8887 2.4037-19.944 3.1582-31.846l-137.25 21.303c-25.909 149.47-138.57 267.14-285.7 298.08-40.461 8.5089-96.519 9.5312-136.68 2.4922-149.76-26.249-266.62-139.54-296.77-287.71-21.666-106.5 5.8072-218.47 74.445-303.41 14.173-17.54 44.08-46.535 62.043-60.15 88.762-67.281 200.82-89.311 304.9-65.053l64.934-121.21c-47.503-14.842-97.001-22.697-146.89-22.873z",
    fill: "#4f0a67",
    strokeWidth: 1.7011
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59948 0 0 .59948 654.52 -1161.6)",
    fill: "#b80099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1806.4-1578.9c-4.5342-0.7131-10.543-4.0267-13.248-7.3055-9.0054-10.917-5.1241-27.719 7.7923-33.734 5.2774-2.4573 13.324-2.4542 18.61 0 7.9705 3.7114 12.455 10.681 12.413 19.291-0.067 13.963-11.768 23.911-25.568 21.741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1718.4-1491.8c-4.5342-0.7131-10.543-4.0267-13.248-7.3055-9.0054-10.917-5.1241-27.719 7.7923-33.734 5.2774-2.4573 13.324-2.4542 18.61 0 7.9705 3.7114 12.455 10.681 12.413 19.291-0.067 13.963-11.768 23.911-25.568 21.741z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1718.4-1404.7c-4.5342-0.7131-10.543-4.0267-13.248-7.3055-9.0054-10.917-5.1241-27.719 7.7923-33.734 5.2774-2.4573 13.324-2.4542 18.61 0 7.9705 3.7114 12.455 10.681 12.413 19.291-0.067 13.963-11.768 23.911-25.568 21.741z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalviaLogo);
export default __webpack_public_path__ + "static/media/salvia-logo.052a8dcc8f0950da7ad0fbaf3e950c27.svg";
export { ForwardRef as ReactComponent };